export enum PlayerPosition {
  Goalkeeper = 1,
  Defender = 2,
  Midfielder = 3,
  Forward = 4
}

export enum PlayerPositionShort {
  GK = 1,
  DEF = 2,
  MID = 3,
  FWD = 4
}
